import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { combineLatest, Observable, Subject, of } from "rxjs";
import { MarketService } from "../../../../../../../../../shared/src/lib/services/market.service";
import { LoaderService } from "../../../../../../../../../shared/src/lib/services/loader.service";
import { ShimmerLoaderComponent } from "../../../../../../shared/components/shimmer-loader/shimmer-loader.component";
import { AsyncPipe, CommonModule } from "@angular/common";
import { filter, map, takeUntil, tap } from "rxjs/operators";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-countries-sub-tab",
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink, ShimmerLoaderComponent],
  templateUrl: "./countries-sub-tab.component.html",
  styleUrl: "./countries-sub-tab.component.scss",
})
export class CountriesSubTabComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject<void>();
  marketService = inject(MarketService);
  loader = inject(LoaderService);
  route = inject(ActivatedRoute);

  sportId = "";
  currentSport = "";
  allCountries: { letter: string; countries: any[] }[] = [];
  countryLeagues: Record<string, any[]> = {};
  loadingLeagues: Record<string, boolean> = {};
  $loading!: Observable<boolean>;

  sportIds: Record<string, string> = {
    soccer: "1",
    cricket: "4",
    tennis: "2",
  };

  ngOnInit() {
    this.$loading = this.loader.isLoading("/bf/countries/");

    this.route.parent?.parent?.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.currentSport = params["sport"];
      this.sportId = this.sportIds[this.currentSport] || "";
      if (this.sportId) {
        this.fetchCountries();
      }
    });
  }

  fetchCountries() {
    this.marketService
      .fetchCountries(this.sportId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: any) => {
        const countries = Array.isArray(resp) ? resp : resp?.data || [];
        this.groupCountries(countries);
      });
  }

  groupCountries(countries: any[]) {
    if (!Array.isArray(countries)) return;
    const sorted = [...countries].sort((a, b) => a.name.localeCompare(b.name));
    const groups: Record<string, any[]> = {};

    sorted.forEach((country) => {
      const firstLetter = country.name.charAt(0).toUpperCase();
      if (!groups[firstLetter]) {
        groups[firstLetter] = [];
      }
      groups[firstLetter].push(country);
    });

    this.allCountries = Object.keys(groups)
      .sort()
      .map((letter) => ({
        letter,
        countries: groups[letter],
      }));
  }

  toggleCountry(country: any, event: MouseEvent) {
    const details = (event.currentTarget as HTMLElement).parentElement as HTMLDetailsElement;
    if (!details.open) {
      if (!this.countryLeagues[country.code]) {
        this.fetchLeagues(country.code);
      }
    }
  }

  fetchLeagues(countryCode: string) {
    this.loadingLeagues[countryCode] = true;
    this.marketService
      .fetchCompetitions(this.sportId, countryCode)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (resp: any) => {
          this.countryLeagues[countryCode] = resp?.data || [];
          this.loadingLeagues[countryCode] = false;
        },
        error: () => {
          this.loadingLeagues[countryCode] = false;
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
